var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCiEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ci:edit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#42CBE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66108 18C6.56972 17.9998 6.4794 17.9807 6.39586 17.9437C6.31231 17.9067 6.23737 17.8528 6.17579 17.7853C6.11311 17.7183 6.06527 17.6389 6.03543 17.5522C6.00558 17.4655 5.9944 17.3734 6.00262 17.2821L6.16394 15.5077L13.6164 8.05581L15.9454 10.3848L8.4949 17.836L6.721 17.9974C6.70108 17.9992 6.68108 18.0001 6.66108 18ZM16.4103 9.91911L14.082 7.59015L15.4786 6.19317C15.5397 6.13193 15.6123 6.08335 15.6923 6.05021C15.7722 6.01706 15.8579 6 15.9444 6C16.031 6 16.1166 6.01706 16.1966 6.05021C16.2765 6.08335 16.3491 6.13193 16.4103 6.19317L17.8069 7.59015C17.8681 7.65132 17.9167 7.72396 17.9498 7.80392C17.9829 7.88388 18 7.96959 18 8.05614C18 8.1427 17.9829 8.2284 17.9498 8.30836C17.9167 8.38832 17.8681 8.46096 17.8069 8.52213L16.4109 9.91845L16.4103 9.91911Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiEdit);
export default __webpack_public_path__ + "static/media/ci_edit.7eab7316760a435f2d172e57be95328f.svg";
export { ForwardRef as ReactComponent };